// extracted by mini-css-extract-plugin
export var chevron = "_ak-2";
export var dropdownItems = "_ak-0";
export var item = "_ak-1";